/*
 * Package Import
 */
import { useMutation, UseMutationResult } from 'react-query';
import { toast } from 'react-toastify';

/*
 * Local Import
 */
import { queryClient } from 'src/serverStateManagers/queries/queryClient';
import { deactivatePromotion } from './deactivatePromotion';

/*
 * Code
 */
export const useDeactivatePromotion = (): UseMutationResult<void, unknown, string, unknown> => {
  const PromotionMutation = useMutation((promotionId: string) => deactivatePromotion(promotionId), {
    onSettled: () => {
      queryClient.invalidateQueries('promotions');
    },
    onSuccess: () => {
      toast('Promotion archivée avec succès !', { type: 'success' });
    },
  });

  return PromotionMutation;
};
